/* tslint:disable */
/* eslint-disable */
/**
 * PR TIMES 企業の管理画面用 API
 * PR TIMES 企業の管理画面で使うAPI。basePathは今後変わる事も想定している。
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PostPressKitBodyTagsInner
 */
export interface PostPressKitBodyTagsInner {
    /**
     * エラー箇所を特定するために必要な各オブジェクトのID
     * @type {string}
     * @memberof PostPressKitBodyTagsInner
     */
    objectId: string;
    /**
     * PressKit Tag UUID(v4)
     * @type {string}
     * @memberof PostPressKitBodyTagsInner
     */
    id: string;
    /**
     * UI上で表示されるタグの名前
     * @type {string}
     * @memberof PostPressKitBodyTagsInner
     */
    name: string;
}

/**
 * Check if a given object implements the PostPressKitBodyTagsInner interface.
 */
export function instanceOfPostPressKitBodyTagsInner(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "objectId" in value;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "name" in value;

    return isInstance;
}

export function PostPressKitBodyTagsInnerFromJSON(json: any): PostPressKitBodyTagsInner {
    return PostPressKitBodyTagsInnerFromJSONTyped(json, false);
}

export function PostPressKitBodyTagsInnerFromJSONTyped(json: any, ignoreDiscriminator: boolean): PostPressKitBodyTagsInner {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'objectId': json['__object_id'],
        'id': json['id'],
        'name': json['name'],
    };
}

export function PostPressKitBodyTagsInnerToJSON(value?: PostPressKitBodyTagsInner | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        '__object_id': value.objectId,
        'id': value.id,
        'name': value.name,
    };
}

